import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Button from "components/CustomButton";
import { Modal } from "react-responsive-modal";
import TeamService from "services/TeamService";
import { useTeamContext } from "store/contexts/teamContext";
import micon from "assets/img/icons/mic_on_watercooler.png";
import micoff from "assets/img/icons/mic_off_watercooler.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import WaterCoolerMemberSelection from "./WaterCoolerMemberSelection";
import Loader from "components/Loader";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import {
  createChannel,
  retreiveData,
  prevMessage,
} from "services/TwilioService";
import { WaterCoolerContext } from "store/contexts/waterCoolerContext";
import useWaterCoolerMessageAdd from "hooks/useWaterCoolerMessageAdd";
import { connectRoom, clearWaterCoolerRoom } from "utils/helpers";
import WaterCoolerPreviewDialog from "components/WaterCoolerPreview/WaterCoolerPreviewDialog";
import WaterCoolerAlert from "components/WaterCoolerAlert";
import "assets/scss/partials/watercooler.scss";
import * as timelineActions from "reteamStore/actions";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useGlobalContext } from "store/contexts/globalContext";
import { scrollToBottomOfWaterCooler } from "utils/helpers";

export default () => {
  const dispatch = useDispatch();
  const [dialogState, setDialogState] = useState(true);
  const { setWaterCoolerActivate } = useGlobalContext();
  const [microphone, setMicrophone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [waterCoolerDialog, setWaterCoolerDialog] = useState(false);
  const [channelInformation, setChannelInformation] = useState(null);
  const messageAdded = useWaterCoolerMessageAdd({ channelInformation });
  const [messageData, setMessageData] = useState();
  const [notSupported, setNotSupported] = useState(false);
  const [allMessages, setAllMessages] = useState();
  const [total, setTotal] = useState("");
  const [room, setRoom] = useState(null);
  const [waterCoolerClosed, setWaterCoolerClosed] = useState(false);
  const [memberSelectionOpen, setMemberSelectionOpen] = useState(false);
  const [roomToken, setRoomToken] = useState();
  const [waterCoolerAlertContent, setwaterCoolerAlertContent] = useState([
    {
      status: "404",
      description: "Water Cooler is closed, kindly create a new water cooler",
    },
    {
      status: "409",
      description:
        "You have already initiated the watercooler, please close existing watercooler before initiaing the other.",
    },
  ]);
  const [selectedMember, setSelectedMember] = useState([]);
  const [localVideo, setLocalVideo] = useState(null);
  const [localAudio, setLocalAudio] = useState(null);
  const { team } = useTeamContext();
  const [initateWaterCooler] = useState(
    team?.users?.length === 1 ? false : true
  );
  const history = useHistory();
  const search = useLocation().search;
  const param = new URLSearchParams(search);
  const waterCoolerStatus = param.get("waterCoolerStatus");
  const post_id = param.get("post_id");
  const private_watercooler = param.get("private");
  const [buttonName, setButtonName] = useState("Start Team Watercooler");

  useEffect(() => {
    if (!waterCoolerStatus) {
      return;
    }
    setButtonName("Join Watercooler");
  }, [waterCoolerStatus]);

  useEffect(() => {
    if (messageAdded.message && messageAdded.message !== undefined) {
      setAllMessages(
        Array.from(new Set([...allMessages, messageAdded.message]))
      );
      // setAllMessages([...allMessages, messageAdded.message]);
      setTotal(total + 1);

      setTimeout(function () {
        scrollToBottomOfWaterCooler();
      }, 1000);
    }

    //eslint-disable-next-line
  }, [messageAdded.message]);

  useEffect(() => {
    if (!room) {
      return;
    }

    if (!localAudio && !localVideo) {
      room.localParticipant.tracks.forEach(function (trackPublication) {
        if (trackPublication.kind === "audio") {
          setLocalAudio(trackPublication);
          return;
        }

        if (trackPublication.kind === "video") {
          setLocalVideo(trackPublication);
          return;
        }
      });
    }

    //eslint-disable-next-line
  }, [room]);

  const closeDialog = () => {
    setDialogState(false);
    history.push(`/teams/${team.id}/timeline`);
  };

  const deleteWaterCoolerPost = () => {
    history.push(`/teams/${team.id}/timeline`);
    var post = {
      id: Number(post_id),
    };

    dispatch(timelineActions.deletePost(post));
  };

  const joinVideoCall = async (token) => {
    try {
      // setLoader(true);
      var response2 = await connectRoom(true, true, token);
      if (response2 === undefined) {
        response2 = await connectRoom(true, false, token);
        setNotSupported({
          type: "video",
          description: "Please attach the web cam to see your video.",
        });
      }
      if (response2 === undefined) {
        response2 = await connectRoom(false, false, roomToken);
      }
      setRoom(response2);
      toggleAudio(response2, microphone);
      toggleVideo(response2, false);
      // setLoader(false);
    } catch (e) {
      console.log(e);
    }
  };

  const joinWaterCooler = async () => {
    try {
      setLoading(true);

      var response = await TeamService.postWaterCooler(
        team.id,
        private_watercooler,
        post_id,
        selectedMember.length !== 0
          ? selectedMember.map((selectedMember) => selectedMember.id)
          : null,
        waterCoolerStatus
      );

      await joinVideoCall(response);

      var channelData = await createChannel(
        response.data.data.token,
        response.data.data.channel.channel_sid
      );

      setRoomToken(response);

      var messages = await retreiveData(channelData);
      setWaterCoolerActivate(true);

      setMessageData(messages);
      setAllMessages(messages.items);
      setChannelInformation(channelData);
      setLoading(false);
      setDialogState(false);
      setWaterCoolerDialog(true);
    } catch (e) {
      console.log(e);

      setwaterCoolerAlertContent(
        waterCoolerAlertContent.filter(
          (alert) => Number(alert.status) === e.response.status
        )
      );
      setWaterCoolerClosed(true);
      setLoading(false);
    }
  };

  const handleScroll = async (val) => {
    try {
      var response = await prevMessage(messageData);
      if (response) {
        setAllMessages(
          Array.from(new Set([...response.items, ...allMessages]))
        );
        setMessageData(response);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const toggleAudio = async (myRoom, microphoneValue) => {
    if (!myRoom) {
      setMicrophone(!microphone);
      return;
    }
    try {
      await myRoom.localParticipant.audioTracks.forEach((publication) => {
        if (!microphoneValue) {
          publication.track.disable();
          setMicrophone(false);
          return;
        }
        publication.track.enable();
        setMicrophone(true);
      });
    } catch (e) {
      console.log(e);
    }
  };

  const toggleVideo = async (myRoom, value) => {
    // if (!myRoom) {
    //   setMicrophone(!microphone);
    //   return;
    // }
    try {
      await myRoom.localParticipant.videoTracks.forEach((publication) => {
        if (!value) {
          publication.track.disable();
          // setMicrophone(false);
          return;
        }
        publication.track.enable();
        // setMicrophone(true);
      });
    } catch (e) {
      console.log(e);
    }
  };

  async function leaveVideoWaterCooler(setLoader) {
    setLoader(true);
    try {
      await clearWaterCoolerRoom(setRoom);
      setLocalAudio(null);
      setLocalVideo(null);
    } catch (e) {
      console.log(e);
    }
    setLoader(false);
  }

  async function closeJoinWaterCooler() {
    try {
      await channelInformation.leave();
      await clearWaterCoolerRoom(setRoom);
      setWaterCoolerDialog(false);
      clearWaterCoolerRoom(setRoom);
      closeDialog();
      setWaterCoolerActivate(false);
      // history.push(`/teams/${team.id}/timeline`);
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <>
      {waterCoolerClosed && (
        <WaterCoolerAlert
          teamId={team.id}
          status={waterCoolerAlertContent[0]?.status}
          content={waterCoolerAlertContent[0]?.description}
          deleteWaterCooler={deleteWaterCoolerPost}
        />
      )}
      {!initateWaterCooler && (
        <WaterCoolerAlert
          teamId={team.id}
          content="Please add members in your team to initiate the watercooler"
        />
      )}
      {initateWaterCooler && (
        <Modal
          closeOnEsc={false}
          closeOnOverlayClick={false}
          classNames={{
            modalContainer: "modalContainer",
            modal: !memberSelectionOpen
              ? "waterCoolerRoot"
              : "waterCoolerCloseRoot",
          }}
          open={dialogState}
          showCloseIcon={false}
          onClose={() => setDialogState(false)}
        >
          <div className="waterCoolerTitleRoot">
            <div className="crossIcon">
              <CancelIcon
                onClick={closeDialog}
                style={{
                  cursor: "pointer",
                  width: "20px",
                  fill: "#000000ab",
                }}
              />
            </div>
            <div className="waterCoolerHeading">
              <h6 style={{ fontSize: "1.25rem", fontWeight: 600 }}>
                Watercooler
              </h6>
              <span
                style={{
                  fontWeight: 500,
                  textTransform: "capitalize",
                  lineHeight: 1.57,
                }}
              >
                A place to get engaged with the team based on chat, audio &
                video features under one umbrella
              </span>
            </div>
          </div>
          <div classes="waterCoolerContentRoot">
            <div className="contentDialog">
              <div className="waterCoolerContent">
                {microphone && (
                  <img
                    className="micOnImage"
                    src={micon}
                    onClick={() => setMicrophone(!microphone)}
                    alt="micon"
                  />
                )}
                {!microphone && (
                  <img
                    className="micOffImage"
                    src={micoff}
                    onClick={() => setMicrophone(!microphone)}
                    alt="micoff"
                  />
                )}
                <Button
                  onClick={joinWaterCooler}
                  type="button"
                  name={
                    !loading ? [buttonName] : <Loader width={40} height={40} />
                  }
                  disabled={loading && true}
                />
                <div style={{ width: "100%" }}>
                  {!waterCoolerStatus && (
                    <WaterCoolerMemberSelection
                      setMemberSelectionOpen={setMemberSelectionOpen}
                      waterCoolerDialogState={setDialogState}
                      team_id={team.id}
                      joinWaterCooler={joinWaterCooler}
                      selectedMember={selectedMember}
                      setSelectedMember={setSelectedMember}
                      loading={loading}
                    >
                      <Button
                        type="button"
                        name={"Start Private Watercooler"}
                        disabled={loading && true}
                      />
                    </WaterCoolerMemberSelection>
                  )}
                </div>
              </div>
              <div className="waterCoolerInformation">
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  className="waterCoolerInformationIcon"
                />
                <span className="waterCoolerInformationText">
                  A secure team conversation where the history will be removed
                  as soon as the watercooler ends.
                </span>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {waterCoolerDialog && (
        <WaterCoolerContext.Provider
          value={{
            microphone,
            toggleAudio,
            localVideo,
            localAudio,
            joinVideoCall,
            toggleVideo,
            leaveVideoWaterCooler,
            setTotal,
            total,
            room,
            notSupported,
            allMessages,
            setAllMessages,
            channelInformation,
            closeJoinWaterCooler,
          }}
        >
          <WaterCoolerPreviewDialog
            closeJoinWaterCooler={closeJoinWaterCooler}
            handleScroll={handleScroll}
          />
        </WaterCoolerContext.Provider>
      )}
    </>
  );
};
